/* eslint-disable */

var boostPFSThemeConfig = boostPFSThemeConfig || {}

var onSale = false
var soldOut = false
var priceVaries = false
var images = []
var firstVariant = {}

Shopify.handleize = function (str) {
  str = str.toLowerCase()

  var toReplace = ['"', "'", '\\', '(', ')', '[', ']']

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], '')
  }

  str = str.replace(/\W+/g, '-')

  if (str.charAt(str.length - 1) == '-') {
    str = str.replace(/-+\z/, '')
  }

  if (str.charAt(0) == '-') {
    str = str.replace(/\A-+/, '')
  }

  return str
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    breakpointMobile: '1023',
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 4,
    placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
    enableOTP: true,
    separateRefineByFromFilter: true
    // filterTreeMobileStyle: 'style2', // 'style2', 'style3',
  },
  selector: {
    otpButtons: '.boost-pfs-filter-product-item-image'
  }
};

(function () {
  BoostPFS.inject(this)

  /** ************************ CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData (data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
    priceVaries = data.price_min != data.price_max // Check a product has many prices
    // Convert images to array
    images = data.images_info
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0]
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant')
      })
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i]
          break
        }
      }
    }
    return data
  }
  /** ************************ END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /** ************************ BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data)
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : ''
    var saleClass = onSale ? boostPFSTemplate.saleClass : ''
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass)
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass)
    // Add Grid Width class
    itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data))
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data))
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false))
        // Add TAG Label - Bollino Extra
    itemHtml = itemHtml.replace(/{{itemTagLabelsbis}}/g, buildTagLabelsbis(data, false))
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data))
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data))

    // Add Review
    if (boostPFSThemeConfig.custom.show_product_review) {
      var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'
      itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml)
    } else {
      itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, '')
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data))
    // itemActiveSwapClass
    var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : ''
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass)
    // Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data))

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, getTitle(data.title, 'pre_title'))
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle)
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildItemUrl(data))
    itemHtml = itemHtml.replace(/{{boxColor}}/, getMetafieldValue(data, 'box_color'))
    itemHtml = itemHtml.replace(/{{collectionTag}}/, getTitle(data.title, 'title'))
    itemHtml = itemHtml.replace(/{{additionalTags}}/, getTitle(data.title, 'post_title'))

    return itemHtml
  }
  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data
    // For List View
    /** * Prepare data ***/
    var images = data.images_info
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
    var priceVaries = data.price_min != data.price_max // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0]
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant')
      })
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i]
          break
        }
      }
    }
    /** * End Prepare data ***/
    // Get Template
    var itemHtml = boostPFSTemplate.productListItemHtml
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data)
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : ''
    var saleClass = onSale ? boostPFSTemplate.saleClass : ''
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass)
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass)
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data))
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false))
      // Add TAG Label - Bollino Extra 
    itemHtml = itemHtml.replace(/{{itemTagLabelsbis}}/g, buildTagLabelsbis(data, false))
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data))

    // Add Review
    if (boostPFSThemeConfig.custom.show_product_review) {
      var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'
      itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml)
    } else {
      itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, '')
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data))
    // Add Price
    var itemPriceHtml = buildPrice(data)
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml)
    // Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text()
    itemDescription = (itemDescription.split(' ')).length > 35 ? itemDescription.split(' ').splice(0, 35).join(' ') + '...' : itemDescription.split(' ').splice(0, 35).join(' ')
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription)
    // itemActiveSwapClass
    var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : ''
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass)
    // Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data))

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildItemUrl(data))
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
    return itemHtml
    // End For List View
  }
  /** ************************ END BUILD PRODUCT LIST **************************/
  /** ************************ BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildGridWidthClass () {
    var gridWidthClass = ''
    // On PC
    switch (boostPFSThemeConfig.custom.products_per_row) {
      case 2:
        gridWidthClass = 'boost-pfs-filter-grid-width-2'
        break
      case 3:
        gridWidthClass = 'boost-pfs-filter-grid-width-3'
        break
      case 5:
        gridWidthClass = 'boost-pfs-filter-grid-width-5'
        break
      default:
        gridWidthClass = 'boost-pfs-filter-grid-width-4'
        break
    }
    // On Mobile
    switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-1'
        break
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-3'
        break
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-2'
        break
    }
    return gridWidthClass
  }

  function buildImages (data) {
	  var html = ''
	  var thumbUrl = Utils.getFeaturedImage(images, '260x')

    html += '<img class="lazyload"' +
		  'data-srcset="' + Utils.getFeaturedImage(images, '180x') + ' ' + '180w' + ', ' + Utils.getFeaturedImage(images, '260x') + ' ' + '260w' + ', ' + Utils.getFeaturedImage(images, '360x') + ' ' + '360w' + '" ' +
		  'data-src="' + thumbUrl + '" ' +
		  'data-widths="[180, 260, 360]" ' +
		  'data-sizes="auto" ' +
		  'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
		  'alt="{{itemTitle}}" />'

	  return html
  }

  function buildVendor (data) {
    var html = ''
    if (boostPFSThemeConfig.custom.show_vendor) {
      html = boostPFSTemplate.vendorHtml
    }
    return html
  }

  function buildPrice (data) {
    var html = ''

    if (data.compare_at_price_min > data.price_min && data.price_min === data.price_max) {
      html = '<del>' + Utils.formatMoney(data.compare_at_price_min) + '</del>' + '<ins>' + Utils.formatMoney(data.price_min) + '</ins>'
    } else {
      if (data.price_min !== data.price_max) {
        html = Utils.formatMoney(data.price_min) + ' - ' + Utils.formatMoney(data.price_max)
      } else {
        html = Utils.formatMoney(data.price_min)
      }
    }

    return html
  }

  function getTitle (title, key) {
    let preTitle = ''
    let _title = ''
    let postTitle = ''
    if (title.indexOf('-') !== -1) {
      const titleArr = title.split(' - ')

      preTitle = titleArr[0];
      _title = titleArr[1];

      if (titleArr.length === 3) {
        postTitle = titleArr[2]
      }
    } else {
      _title = title
    }

    switch (key) {
      case 'title':
        return _title

      case 'pre_title':
        return preTitle

      case 'post_title':
        return postTitle

      default:
        return _title
    }
  }

  function getMetafieldValue (data, key) {
    var metafield = data.metafields.filter(metafield => metafield.key === key)[0]

    return metafield ? metafield.value : ''
  }

  function buildLabels (data) {
    // Build Sold out label
    var soldOutLabel = ''
    if (boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '')
    }
    // Build Sale label
    var saleLabel = ''
    if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '')
    }
    // Build Labels
    return soldOutLabel + saleLabel
  }
  // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabels (data, showall) {
    var tagLabel = ''
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i]
        if (tag.indexOf('badge:') !== -1) {
          var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('badge:')[1])
          preTagLabel = preTagLabel.replace(/{{labelTagHandle}}/g, Shopify.handleize(tag.split('badge:')[1]))
          tagLabel += preTagLabel
          break
        }     
      }
    }

    return tagLabel
  } 
  
    // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabelsbis (data, showall) {
    var tagLabelbis = ''
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i]
        if (tag.indexOf('promo:') !== -1) {
          var preTagLabelbis = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('promo:')[1])
          preTagLabelbis = preTagLabelbis.replace(/{{labelTagHandle}}/g, Shopify.handleize(tag.split('promo:')[1]))
          tagLabelbis += preTagLabelbis
          break
        }     
      }
    }

    return tagLabelbis
  } 
 

  



  function buildItemUrl(data) {
    return '/products/' + data.handle;
  }

  // Build Color Swatches
  function buildColorSwatches (data) {
    var colorSwatchesHtml = ''
    if (boostPFSThemeConfig.custom.display_item_swatch) {
      colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">'
      for (var index = 0; index < data.options.length; index++) {
        var option = data['options'][index].toLowerCase()
        if (option == 'color') {
          var colorlist = ''
          var color = ''
          var totalVariants = 0
          for (var k = 0; k < data.variants.length; k++) {
            var variant = data['variants'][k]
            color = variant['options'][index]
            if (colorlist.indexOf(color) == -1) {
              if (totalVariants < 4) {
                var text = Utils.slugify(color)
                var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : ''
                var backgroundImage = Utils.optimizeImage(variant.image, '24x')
                var backgroundImageURL = ''
                var dataImg = ''
                var dataColor = '#fff'
                dataColors = variant.option_color.toLowerCase().split(' ')
                var i = dataColors.length - 1
                if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
                  dataColor = dataColors[i]
                }

                if (variant.image !== null) {
                  dataImg = "data-img='" + Utils.optimizeImage(variant.image, '300x') + " 300w'"
                }

                // if (variant.image !== null) {
                // 	dataImg = "data-img='" + Utils.optimizeImage(variant.image) + "'";
                // } else {
                // 	var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
                // 	backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png';
                // }

                var _file = variant.option_color.toLowerCase().replace(/ /g, '-')
                if (boostPFSThemeConfig.custom.swatch_color_display_type == 'swatch_color_display_type_image_color') {
                  backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png?v=' + boostPFSAppConfig.general.file_url.split('?')[1]
                  backgroundImageURL = 'url(' + backgroundImage + ')'
                } else if (boostPFSThemeConfig.custom.swatch_color_display_type == 'swatch_color_display_type_image_product') {
                  backgroundImage = Utils.optimizeImage(variant.image, '24x')
                  backgroundImageURL = 'url(' + backgroundImage + ')'
                } else {
                  backgroundImageURL = 'none'
                }
                colorSwatchesHtml += '<li>'
                colorSwatchesHtml += '<div class="tooltip">' + color + '</div>'
                colorSwatchesHtml += '<label style="background-color: ' + dataColor + '; background-image: ' + backgroundImageURL + ';" ' + dataImg + '></label>'

                // colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + Utils.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + Utils.optimizeImage(variant.image) + '"' + } '></label>';
                colorSwatchesHtml += '</li>'
              }
              var templist = colorlist + color + ' '
              colorlist = templist

              totalVariants++
            }
          }
          // if (totalVariants == 1) {
          // colorSwatchesHtml = '<ul class="boost-pfs-filter-item-swatch">';
          // }
          if (totalVariants > 4) {
            colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">'
            colorSwatchesHtml += '<a href="{{itemUrl}}" title="More Color">+' + (totalVariants - 4) + '</a>'
            colorSwatchesHtml += '</li>'
            totalVariants = 0
          }
        }
      }
      colorSwatchesHtml += '</ul>'
    }
    return colorSwatchesHtml
  }

  // Build Color Swatches
  function eventColorSwatches (event) {
    jQ('.boost-pfs-filter-item-swatch li label').each(function () {
      var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image')
      if (event == 'hover') {
        jQ(this).hover(function () {
          var newImage = jQ(this).data('img')
          img.attr('srcset', newImage)
        })
      }
      if (event == 'click') {
        jQ(this).click(function () {
          var newImage = jQ(this).data('img')
          img.attr('srcset', newImage)
        })
      }
    })
  }

  /** ************************ END BUILD PRODUCT ITEM ELEMENTS **************************/
  /** ************************ BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page)
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit)
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return ''
    }
    if (Settings.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = boostPFSTemplate.paginateHtml
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1))
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1))
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)
      // Create page items array
      var beforeCurrentPageArr = []
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore)
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...')
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1)
      }
      beforeCurrentPageArr.push(currentPage)
      var afterCurrentPageArr = []
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter)
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...')
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage)
      }
      // Build page items
      var pageItemsHtml = ''
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]))
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)
      return paginationHtml
    }
  }

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = ''
    if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList()
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || ''
        // Build content
        var sortingItemsHtml = ''
        for (var k in sortingArr) {
          activeClass = ''
          if (paramSort == k) {
            activeClass = 'boost-pfs-filter-sort-item-active'
          }
          sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>'
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml)
      }
    }
    return html
  }

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate())

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active')
    }

    var labelSort = ''
    var paramSort = Globals.queryParams.sort || ''
    if (paramSort.length > 0) {
      var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_')
      labelSort = Labels[labelHandle]
    } else {
      labelSort = Labels.sorting_heading
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort)
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var _this = this
    jQ('.boost-pfs-filter-filter-dropdown a').click(function (e) {
      e.preventDefault()
      FilterApi.setParam('sort', jQ(this).data('sort'))
      FilterApi.setParam('page', 1)
      FilterApi.applyFilter('sort')
    })

    jQ('.boost-pfs-filter-custom-sorting > button').click(function () {
      if (!$('.boost-pfs-filter-filter-dropdown').is(':animated')) {
        jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active')
        // jQ('.boost-pfs-filter-tree-v').hide();
      }
    })

    jQ(Selector.filterTreeMobileButton).click(function () {
      jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide()
    })
  }
  // For Toolbar - Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>'
    itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>'
    itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>'
    itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType)

    return itemHtml
  }

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function () {
    var html = ''
    if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
      var numberList = Settings.getSettingValue('general.showLimitList')
      if (numberList != '') {
        // Build content
        var showLimitItemsHtml = ''
        var arr = numberList.split(',')
        for (var k in sortingArr) {
          showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>'
        }
        html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml)
      }
    }
    return html
  }
  // Build Breadcrumb
  Breadcrumb.prototype.compileTemplate = function (colData) {
    if (!colData) colData = this.collectionData
    var breadcrumbItemsHtml = ''
    if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
      if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection
        if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title)
          breadcrumbItemsHtml += ' {{breadcrumbDivider}} '
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0])
        } else {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title)
        }
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'))
      }
    }
    return breadcrumbItemsHtml
  }
  /** ************************ END BUILD TOOLBAR **************************/
  function matchHeightImage () {
    // jQ('.boost-pfs-filter-product-item-main-image').load(function() {
    // 	var imageContainer = jQ(this).parent();
    // 	imageContainer.css('width', '100%').css('height', jQ(this).height());
    // }).each(function() {
    // 	if (this.complete) jQ(this).load();
    // });
  }

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
      eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image)
    }

    if (!data) data = this.data

    // Intergrate Review Shopify
    if (window.SPR && boostPFSThemeConfig.custom.show_product_review) {
      window.SPR.initDomEls()
      window.SPR.loadBadges()
    }
  }

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data


    jQ('.js-button').on('click', function() {
      if (jQ(this).hasClass('js-button-next')) {
        jQ('.boost-pfs-filter-options-wrapper').animate({scrollLeft: jQ('.boost-pfs-filter-options-wrapper').scrollLeft() + (jQ(window).width() / 2)}, 300);

        return false;
      } else {
        jQ('.boost-pfs-filter-options-wrapper').animate({scrollLeft: jQ('.boost-pfs-filter-options-wrapper').scrollLeft() - (jQ(window).width() / 2)}, 300);

        return false;
      }
    })

    if (data.event_type === 'init') {
      jQ('.collection__body').addClass('js-loaded')
    }

    if (jQ('.boost-pfs-filter-clear-all').length) {
      jQ('.boost-pfs-filter-clear-all').appendTo('.collection__filter');
    } else {
      jQ('.boost-pfs-filter-clear-all').remove();
    }

    jQ('.js-filter-container .filter-block').each(function(){
      var $block = jQ(this);
      var tagHandle = $block.attr('data-tag-handle');
      var tagValue = $block.attr('data-tag-value');
      var $filterCategory = jQ('.boost-pfs-filter-option-' + tagHandle);

      $filterCategory.find('.boost-pfs-filter-option-value').each(function(){
        var value = jQ(this).html();

        if (value === tagValue) {
          jQ(this).empty();
          $block.clone().appendTo(jQ(this));
        }
      })
    })

    var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>'
    if (data.total_product == 1) {
      totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>'
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct)
    matchHeightImage()
    jQ(window).resize(function () {
      matchHeightImage()
    })

    jQ('body').find('.boost-pfs-filter-skeleton-button').remove()

    // Prevent double tap on iOS
    var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    if (isiOS) {
      Utils.isMobile() && jQ('.boost-pfs-filter-product-item').find('a').on('touchstart', function () { isScrolling = !1 }).on('touchmove', function () { isScrolling = !0 }).on('touchend', function () { isScrolling || (window.location = jQ(this).attr('href')) })
    }

    // Fix image not loaded on mobile
    // (Utils.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));

    // Build Image Swap
    // swapImage(data)
  }

  Filter.prototype.isRender = function () {
    return this.isFetchedFilterData || this.isFetchedProductData
  }
  var originalFilterRender = Filter.prototype.render
  Filter.prototype.render = function () {
    if (this.isFetchedFilterData) {
      originalFilterRender.call(this)
    }
  }

  ProductListPlaceholder.prototype.render = function () {
    // Set limit number for product skeleton
    var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow
    // Build placeholder items
    var placeholderItem = this.compileTemplate()
    this.$element = []
    for (var i = 0; i < placeholderLimit; i++) {
		  this.$element.push(jQ(placeholderItem))
    }
    // Show placeholder before send filter request OR hide it after get filter data
    if (!this.isFetchedProductData) {
		  this.setShow()
    } else {
		  this.setHide()
    }
  }

  ProductListPlaceholder.prototype.compileTemplateExtra = function () {
    var display = Globals.queryParams.display
    switch (display) {
      case 'list':
        // Todo: Build placeholder for List mode
        var template = boostPFSTemplate.productListPlaceholderHtml
        var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio)
        var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4 // It mean w1:h1.4
        /**
			 * Set product class for product skeleton (to set column, style, etc.)
			 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
			 */
        break
    }
    return template
      .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
      .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
      .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
      .replace(/{{paddingTop}}/g, imgRatio * 100)
  }

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function (a, b) {}

  // Swap Image
  function swapImage (data) {
    if (!Utils.isMobile()) {
      if (boostPFSThemeConfig.custom.active_image_swap) {
        var thumbUrl = Utils.getFeaturedImage(images, '260x')

        jQ('.boost-pfs-filter-product-item').each(function () {
          var flipImageUrl = jQ(this).find('.boost-pfs-filter-product-item-main-image').data('img-flip')
          var flipImageSrcset = jQ(this).find('.boost-pfs-filter-product-item-main-image').data('img-flip-srcset')

          var html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
            'data-srcset="' + flipImageSrcset + '" ' +
            'data-src="' + flipImageUrl + '" ' +
            'data-widths="[180, 260, 360]" ' +
            'data-sizes="auto" ' +
            'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
            'alt="' + data.title + '" />'

          jQ(this).find('.boost-pfs-filter-product-item-image-link').prepend(html)
        })
      }
    }
  }
})()